import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field as BaseField } from "rc-field-form";
import { useTranslation } from "react-i18next";
import { UncontrolledTooltip } from "reactstrap";
import Field from "../../../../../../components/Field";
import Switch from "../../../../../../components/Inputs/Switch";
import PayCodeSelect from "./PayCodeSelect";

const hourTypes = ["regular", "unpaid"];

function PunchPayCodes({ disabled }) {
    const { t } = useTranslation();

    return (
        <div className="border-bottom mb-5">
            <div className="mb-4">
                <Field
                    name={["punchPayCodes", "status"]}
                    valuePropName="checked"
                >
                    <Switch disabled={disabled}>
                        <h3 className="m-0 p-0 d-flex align-items-center">
                            {t("pay-code-punch")}
                            <FontAwesomeIcon
                                id="punch-pay-codes-info"
                                icon={faInfoCircle}
                                className="ml-2 text-muted"
                                size="sm"
                            />
                        </h3>
                    </Switch>
                </Field>
                <UncontrolledTooltip target="punch-pay-codes-info" placement="top">
                    {t("pay-code-punch-tooltip")}
                </UncontrolledTooltip>

                <BaseField shouldUpdate>
                    {({ }, { }, { getFieldValue }) => {
                        const status = getFieldValue(["punchPayCodes", "status"]);

                        if (!status) return null;

                        return (
                            <PayCodeSelect
                                hourTypes={hourTypes}
                                name={["punchPayCodes", "payCodes"]}
                                label="pay-codes"
                                rules={[
                                    {
                                        required: true,
                                        message: t("required-pay-codes"),
                                    },
                                ]}
                                disabled={disabled}
                            />
                        );
                    }}
                </BaseField>
            </div>
        </div>
    );
}

export default PunchPayCodes;
